import template from './copyLine.html' with { type: 'html' };

export default {
	name: 'CCopyLine',
	props: {
		label: {
			type: String,
			required: true
		},
		labelFor: {
			type: String,
			default: ''
		},
		unformattedValue: {
			type: Number,
			default: null
		},
		value: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			valueCopied: false
		};
	},
	methods: {
		copyToClipboard(value) {
			const element = document.createElement('textarea');
			element.value = value;
			document.body.appendChild(element);
			element.select();
			document.execCommand('copy');
			document.body.removeChild(element);
			this.valueCopied = true;
			setTimeout(() => {
				this.valueCopied = false;
			}, 1000);
		}
	},
	template
};
